import React, { memo } from 'react';

import { makeStyles } from '@mui/styles';
import SvgIcon from '@mui/material/SvgIcon';

const useStyles = makeStyles({
  icon: {
    width: '1.5rem',
    height: '1.5rem',
    fillOpacity: '0.87',
  },
});

const ListExpanded = () => {
  const styles = useStyles();

  return (
    <SvgIcon viewBox="0 0 24 24" className={styles.icon} fill="white">
      <path d="M0 0H24V6H0V0Z" />
      <path d="M0 9H24V15H0V9Z" />
      <path d="M0 18H24V24H0V18Z" />
    </SvgIcon>
  );
};

export default memo(ListExpanded);
